import { SxProps } from '@mui/material'

export default {
  header: {
    backgroundColor: '#FBF5F1',
    color: 'black',
  },
  toolbar: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  menuIcon: {
    display: { xs: 'block', md: 'none' },
    width: 40,
    height: 40,
    color: 'primary.main',
  },
  linksContainer: {
    display: { xs: 'none', md: 'flex' },
    gap: 2,
  },
  languageSelector: {
    color: 'primary.main',

    '&::before': {
      borderColor: 'primary.main',
    },
    '& > .MuiNativeSelect-icon': {
      color: 'primary.main',
    },
  },
  desktopLanguageSelector: {
    display: { xs: 'none', md: 'block' },
  },
  drawerContainer: {
    height: '100vh',
    backgroundColor: '#FBF5F1',
  },
  drawer: {
    display: {
      xs: 'block',
      md: 'none',
    },
    height: '100%',
  },
  languageSelectorContainer: {
    justifyContent: 'flex-end',
    paddingRight: 2,
  },
  drawerItem: {
    fontSize: 14,
    fontWeight: 500,
    textAlign: 'center',
    textTransform: 'uppercase',
    color: 'primary.main',
  },
} satisfies SxProps
